import { StackProps } from '@mantine/core';

import { Project } from 'models';

import { useCompanyProfile } from 'hooks/use-company-profile';
import { useCurrentUser } from 'hooks/use-current-user';
import { useUser } from 'hooks/use-user';

const DesignLibraryTeaserCreatedBy = ({
    project,
}: {
    project: Project;
} & StackProps) => {
    const {
        createdBy,
        template: { profile },
    } = project;

    const currentUser = useCurrentUser();

    const { user } = useUser(currentUser ? createdBy : undefined);

    const { company } = useCompanyProfile(profile ?? null);

    if (company) {
        return <>Designed by {company.name}</>;
    }

    if (user) {
        return <>Designed by {user.name}</>;
    }

    return null;
};

export { DesignLibraryTeaserCreatedBy };
